import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }

function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }

function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }

function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }

function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }

function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }

function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }

function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }

function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

var _Symbol$for;

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
/**
 * This plugin is currently a A Big Hack™! The core reason for that is how this plugin
 * interacts with Uppy's current pipeline design. The pipeline can handle files in steps,
 * including preprocessing, uploading, and postprocessing steps. This plugin initially
 * was designed to do its work in a preprocessing step, and let XHRUpload deal with the
 * actual file upload as an uploading step. However, Uppy runs steps on all files at once,
 * sequentially: first, all files go through a preprocessing step, then, once they are all
 * done, they go through the uploading step.
 *
 * For S3, this causes severely broken behaviour when users upload many files. The
 * preprocessing step will request S3 upload URLs that are valid for a short time only,
 * but it has to do this for _all_ files, which can take a long time if there are hundreds
 * or even thousands of files. By the time the uploader step starts, the first URLs may
 * already have expired. If not, the uploading might take such a long time that later URLs
 * will expire before some files can be uploaded.
 *
 * The long-term solution to this problem is to change the upload pipeline so that files
 * can be sent to the next step individually. That requires a breaking change, so it is
 * planned for some future Uppy version.
 *
 * In the mean time, this plugin is stuck with a hackier approach: the necessary parts
 * of the XHRUpload implementation were copied into this plugin, as the MiniXHRUpload
 * class, and this plugin calls into it immediately once it receives an upload URL.
 * This isn't as nicely modular as we'd like and requires us to maintain two copies of
 * the XHRUpload code, but at least it's not horrifically broken :)
 */


import BasePlugin from '@uppy/core/lib/BasePlugin.js';
import { RateLimitedQueue, internalRateLimitedQueue } from '@uppy/utils/lib/RateLimitedQueue';
import { RequestClient } from '@uppy/companion-client';
import { filterNonFailedFiles, filterFilesToEmitUploadStarted } from '@uppy/utils/lib/fileFilters';
var packageJson = {
  "version": "3.1.1"
};
import MiniXHRUpload from './MiniXHRUpload.js';
import isXml from './isXml.js';
import locale from './locale.js';

function resolveUrl(origin, link) {
  // DigitalOcean doesn’t return the protocol from Location
  // without it, the `new URL` constructor will fail
  if (!origin && !link.startsWith('https://') && !link.startsWith('http://')) {
    link = "https://".concat(link); // eslint-disable-line no-param-reassign
  }

  return new URL(link, origin || undefined).toString();
}
/**
 * Get the contents of a named tag in an XML source string.
 *
 * @param {string} source - The XML source string.
 * @param {string} tagName - The name of the tag.
 * @returns {string} The contents of the tag, or the empty string if the tag does not exist.
 */


function getXmlValue(source, tagName) {
  var start = source.indexOf("<".concat(tagName, ">"));
  var end = source.indexOf("</".concat(tagName, ">"), start);
  return start !== -1 && end !== -1 ? source.slice(start + tagName.length + 2, end) : '';
}

function assertServerError(res) {
  if (res && res.error) {
    var error = new Error(res.message);
    Object.assign(error, res.error);
    throw error;
  }

  return res;
}

function validateParameters(file, params) {
  var valid = params != null && typeof params.url === 'string' && (_typeof(params.fields) === 'object' || params.fields == null);

  if (!valid) {
    var err = new TypeError("AwsS3: got incorrect result from 'getUploadParameters()' for file '".concat(file.name, "', expected an object '{ url, method, fields, headers }' but got '").concat(JSON.stringify(params), "' instead.\nSee https://uppy.io/docs/aws-s3/#getUploadParameters-file for more on the expected format."));
    throw err;
  }

  var methodIsValid = params.method == null || /^p(u|os)t$/i.test(params.method);

  if (!methodIsValid) {
    var _err = new TypeError("AwsS3: got incorrect method from 'getUploadParameters()' for file '".concat(file.name, "', expected  'put' or 'post' but got '").concat(params.method, "' instead.\nSee https://uppy.io/docs/aws-s3/#getUploadParameters-file for more on the expected format."));

    throw _err;
  }
} // Get the error data from a failed XMLHttpRequest instance.
// `content` is the S3 response as a string.
// `xhr` is the XMLHttpRequest instance.


function defaultGetResponseError(content, xhr) {
  // If no response, we don't have a specific error message, use the default.
  if (!isXml(content, xhr)) {
    return undefined;
  }

  var error = getXmlValue(content, 'Message');
  return new Error(error);
} // warning deduplication flag: see `getResponseData()` XHRUpload option definition


var warnedSuccessActionStatus = false; // TODO deprecate this, will use s3-multipart instead

var _client = /*#__PURE__*/_classPrivateFieldLooseKey("client");

var _requests = /*#__PURE__*/_classPrivateFieldLooseKey("requests");

var _uploader = /*#__PURE__*/_classPrivateFieldLooseKey("uploader");

var _handleUpload = /*#__PURE__*/_classPrivateFieldLooseKey("handleUpload");

var _setCompanionHeaders = /*#__PURE__*/_classPrivateFieldLooseKey("setCompanionHeaders");

_Symbol$for = Symbol.for('uppy test: getClient');

var AwsS3 = /*#__PURE__*/function (_BasePlugin, _Symbol$for2) {
  _inherits(AwsS3, _BasePlugin);

  var _super = _createSuper(AwsS3);

  function AwsS3(uppy, opts) {
    var _this;

    _classCallCheck(this, AwsS3);

    _this = _super.call(this, uppy, opts);
    Object.defineProperty(_assertThisInitialized(_this), _client, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), _requests, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), _uploader, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), _handleUpload, {
      writable: true,
      value: function () {
        var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fileIDs) {
          var paramsPromises, onremove, files, filesFiltered, filesToEmit, getUploadParameters, numberOfFiles;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  onremove = function _onremove(file) {
                    var _paramsPromises$id;

                    var id = file.id;
                    (_paramsPromises$id = paramsPromises[id]) == null ? void 0 : _paramsPromises$id.abort();
                  };

                  /**
                   * keep track of `getUploadParameters()` responses
                   * so we can cancel the calls individually using just a file ID
                   *
                   * @type {Record<string, import('@uppy/utils/lib/RateLimitedQueue').AbortablePromise<unknown>>}
                   */
                  paramsPromises = Object.create(null);

                  _this.uppy.on('file-removed', onremove);

                  files = _this.uppy.getFilesByIds(fileIDs);
                  filesFiltered = filterNonFailedFiles(files);
                  filesToEmit = filterFilesToEmitUploadStarted(filesFiltered);

                  _this.uppy.emit('upload-start', filesToEmit);

                  getUploadParameters = _classPrivateFieldLooseBase(_assertThisInitialized(_this), _requests)[_requests].wrapPromiseFunction(function (file) {
                    return _this.opts.getUploadParameters(file);
                  });
                  numberOfFiles = fileIDs.length;
                  return _context.abrupt("return", Promise.allSettled(fileIDs.map(function (id, index) {
                    paramsPromises[id] = getUploadParameters(_this.uppy.getFile(id));
                    return paramsPromises[id].then(function (params) {
                      delete paramsPromises[id];

                      var file = _this.uppy.getFile(id);

                      validateParameters(file, params);
                      var _params$method = params.method,
                          method = _params$method === void 0 ? 'post' : _params$method,
                          url = params.url,
                          fields = params.fields,
                          headers = params.headers;
                      var xhrOpts = {
                        method: method,
                        formData: method.toLowerCase() === 'post',
                        endpoint: url,
                        allowedMetaFields: fields ? Object.keys(fields) : []
                      };

                      if (headers) {
                        xhrOpts.headers = headers;
                      }

                      _this.uppy.setFileState(file.id, {
                        meta: _objectSpread(_objectSpread({}, file.meta), fields),
                        xhrUpload: xhrOpts
                      });

                      return _classPrivateFieldLooseBase(_assertThisInitialized(_this), _uploader)[_uploader].uploadFile(file.id, index, numberOfFiles);
                    }).catch(function (error) {
                      delete paramsPromises[id];

                      var file = _this.uppy.getFile(id);

                      _this.uppy.emit('upload-error', file, error);

                      return Promise.reject(error);
                    });
                  })).finally(function () {
                    // cleanup.
                    _this.uppy.off('file-removed', onremove);
                  }));

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function value(_x) {
          return _value.apply(this, arguments);
        }

        return value;
      }()
    });
    Object.defineProperty(_assertThisInitialized(_this), _setCompanionHeaders, {
      writable: true,
      value: function value() {
        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _client)[_client].setCompanionHeaders(_this.opts.companionHeaders);

        return Promise.resolve();
      }
    });
    _this.type = 'uploader';
    _this.id = _this.opts.id || 'AwsS3';
    _this.title = 'AWS S3';
    _this.defaultLocale = locale;
    var defaultOptions = {
      timeout: 30 * 1000,
      limit: 0,
      allowedMetaFields: [],
      // have to opt in
      getUploadParameters: _this.getUploadParameters.bind(_assertThisInitialized(_this)),
      companionHeaders: {}
    };
    _this.opts = _objectSpread(_objectSpread({}, defaultOptions), opts);

    if ((opts == null ? void 0 : opts.allowedMetaFields) === undefined && 'metaFields' in _this.opts) {
      throw new Error('The `metaFields` option has been renamed to `allowedMetaFields`.');
    } // TODO: remove i18n once we can depend on XHRUpload instead of MiniXHRUpload


    _this.i18nInit();

    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _client)[_client] = new RequestClient(uppy, opts);
    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _requests)[_requests] = new RateLimitedQueue(_this.opts.limit);
    return _this;
  }

  _createClass(AwsS3, [{
    key: _Symbol$for2,
    value: function value() {
      return _classPrivateFieldLooseBase(this, _client)[_client];
    } // TODO: remove getter and setter for #client on the next major release

  }, {
    key: "client",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _client)[_client];
    }
  }, {
    key: "client",
    set: function set(client) {
      _classPrivateFieldLooseBase(this, _client)[_client] = client;
    }
  }, {
    key: "getUploadParameters",
    value: function getUploadParameters(file) {
      if (!this.opts.companionUrl) {
        throw new Error('Expected a `companionUrl` option containing a Companion address.');
      }

      var filename = file.meta.name;
      var type = file.meta.type;
      var metadata = Object.fromEntries(this.opts.allowedMetaFields.filter(function (key) {
        return file.meta[key] != null;
      }).map(function (key) {
        return ["metadata[".concat(key, "]"), file.meta[key].toString()];
      }));
      var query = new URLSearchParams(_objectSpread({
        filename: filename,
        type: type
      }, metadata));
      return _classPrivateFieldLooseBase(this, _client)[_client].get("s3/params?".concat(query)).then(assertServerError);
    }
  }, {
    key: "install",
    value: function install() {
      var _xhrOptions;

      var uppy = this.uppy;
      uppy.addPreProcessor(_classPrivateFieldLooseBase(this, _setCompanionHeaders)[_setCompanionHeaders]);
      uppy.addUploader(_classPrivateFieldLooseBase(this, _handleUpload)[_handleUpload]); // Get the response data from a successful XMLHttpRequest instance.
      // `content` is the S3 response as a string.
      // `xhr` is the XMLHttpRequest instance.

      function defaultGetResponseData(content, xhr) {
        var opts = this; // If no response, we've hopefully done a PUT request to the file
        // in the bucket on its full URL.

        if (!isXml(content, xhr)) {
          if (opts.method.toUpperCase() === 'POST') {
            if (!warnedSuccessActionStatus) {
              uppy.log('[AwsS3] No response data found, make sure to set the success_action_status AWS SDK option to 201. See https://uppy.io/docs/aws-s3/#POST-Uploads', 'warning');
              warnedSuccessActionStatus = true;
            } // The responseURL won't contain the object key. Give up.


            return {
              location: null
            };
          } // responseURL is not available in older browsers.


          if (!xhr.responseURL) {
            return {
              location: null
            };
          } // Trim the query string because it's going to be a bunch of presign
          // parameters for a PUT request—doing a GET request with those will
          // always result in an error


          return {
            location: xhr.responseURL.replace(/\?.*$/, '')
          };
        }

        return {
          // Some S3 alternatives do not reply with an absolute URL.
          // Eg DigitalOcean Spaces uses /$bucketName/xyz
          location: resolveUrl(xhr.responseURL, getXmlValue(content, 'Location')),
          bucket: getXmlValue(content, 'Bucket'),
          key: getXmlValue(content, 'Key'),
          etag: getXmlValue(content, 'ETag')
        };
      }

      var xhrOptions = (_xhrOptions = {
        fieldName: 'file',
        responseUrlFieldName: 'location',
        timeout: this.opts.timeout
      }, _defineProperty(_xhrOptions, internalRateLimitedQueue, _classPrivateFieldLooseBase(this, _requests)[_requests]), _defineProperty(_xhrOptions, "responseType", 'text'), _defineProperty(_xhrOptions, "getResponseData", this.opts.getResponseData || defaultGetResponseData), _defineProperty(_xhrOptions, "getResponseError", defaultGetResponseError), _xhrOptions); // TODO: remove i18n once we can depend on XHRUpload instead of MiniXHRUpload

      xhrOptions.i18n = this.i18n; // Revert to `uppy.use(XHRUpload)` once the big comment block at the top of
      // this file is solved

      _classPrivateFieldLooseBase(this, _uploader)[_uploader] = new MiniXHRUpload(uppy, xhrOptions);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.uppy.removePreProcessor(_classPrivateFieldLooseBase(this, _setCompanionHeaders)[_setCompanionHeaders]);
      this.uppy.removeUploader(_classPrivateFieldLooseBase(this, _handleUpload)[_handleUpload]);
    }
  }]);

  return AwsS3;
}(BasePlugin, _Symbol$for);

export { AwsS3 as default };
AwsS3.VERSION = packageJson.version;